import { render, staticRenderFns } from "./ProAvatar.vue?vue&type=template&id=4cc1e72c&scoped=true&"
import script from "./ProAvatar.vue?vue&type=script&lang=js&"
export * from "./ProAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ProAvatar.vue?vue&type=style&index=0&id=4cc1e72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc1e72c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc1e72c')) {
      api.createRecord('4cc1e72c', component.options)
    } else {
      api.reload('4cc1e72c', component.options)
    }
    module.hot.accept("./ProAvatar.vue?vue&type=template&id=4cc1e72c&scoped=true&", function () {
      api.rerender('4cc1e72c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ProAvatar.vue"
export default component.exports